<template>
  <BModal
    id="modal-pin-custom"
    ref="modal-pin-custom"
    no-stacking
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    size="md"
    hide-header
  >
    <div
      class="text-center text-black"
    >
      <div class="pt-2">
        <div
          class="text-24-bold"
        >
          Masukan PIN
        </div>
        <br>
        <div
          class="text-14-normal mb-1"
        >
          Masukan PIN kamu
        </div>
        <div
          id="pin"
          class="flex flex-row justify-center text-center px-4"
        >
          <CodeInput
            :style="!showPin ?'-webkit-text-security: disc' : '-webkit-text-security: none'"
            :loading="false"
            type="number"
            @change="onChangeConfirm"
          />
        </div>
        <div
          v-if="errorPin"
          class="text-danger font-bold mt-1"
        >PIN Tidak Sesuai</div>
        <div
          class="text-primary mt-2"
          type="button"
          @click="setShowPin()"
        >
          {{ !showPin ? 'Tampilkan' : 'Sembunyikan' }}
        </div>
        <br>
        <div class="my-1">
          <BButton
            variant="outline-primary"
            class="w-44"
            @click="closeModal"
          >
            Kembali
          </BButton>
          <BButton
            :variant="disableBtn ? 'secondary' : 'primary'"
            class="ml-1 w-44"
            :disabled="disableBtn"
            @click="onFinish"
          >
            <BSpinner
              v-if="isLoading"
              variant="light"
              small
            />
            Konfirmasi
          </BButton>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import { newAxiosIns } from '@/libs/axios'
import CodeInput from 'vue-verification-code-input'

export default {
  components: { BButton, BSpinner, CodeInput },
  props: {
    modalValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      disableBtn: true,
      pinDigits: '',
      showPin: false,
      errorPin: false,
    }
  },
  methods: {
    onChangeConfirm(value) {
      this.pinDigits = value
      this.errorPin = false
      if (this.pinDigits.length === 6) {
        this.disableBtn = false
      } else {
        this.disableBtn = true
      }
    },
    setShowPin() {
      this.showPin = !this.showPin
    },
    async onFinish() {
      this.isLoading = true
      this.disableBtn = true

      let textToast = ''
      let url = ''
      const userId = this.modalValue.user_id

      const body = {
        pin: Number(this.pinDigits),
        nominal: this.modalValue.nominal,
        notes: this.modalValue.notes,
      }

      if (this.modalValue.type === 'TopupManual') {
        textToast = 'Berhasil menambahkan saldo user'
        url = 'topup'
      } else if (this.modalValue.type === 'BalanceReduction') {
        textToast = 'Berhasil mengurangi saldo user'
        url = 'deduct'
      } else if (this.modalValue.type === 'TransferSaldo') {
        textToast = 'Berhasil mentransfer saldo user'
        url = 'transfer'
        body.email = this.modalValue.email
      }

      const endpoint = `/auth/api/v1/admin/user/${userId}/${url}`
      await newAxiosIns
        .post(endpoint, body)
        .then(() => {
          this.$toast_success({ message: textToast })
          this.isLoading = false
          this.disableBtn = true
          this.$emit('update-user-data')
          this.closeModal()
        })
        .catch(err => {
          this.$toast_error({ message: err.response.data.meta.message })
          this.isLoading = false
          this.disableBtn = true
        })
    },
    closeModal() {
      this.isLoading = false
      this.disableBtn = true
      this.errorPin = false
      this.modalValue.notes = ''
      this.modalValue.email = ''
      this.modalValue.nominal = 0
      this.modalValue.emailRequired = false
      this.$nextTick(() => {
        this.$bvModal.hide('modal-pin-custom')
      })
    },
  },
}
</script>
